import { render, staticRenderFns } from "./UpdateEmailSuccess.vue?vue&type=template&id=e933f0e6"
import script from "./UpdateEmailSuccess.vue?vue&type=script&lang=ts"
export * from "./UpdateEmailSuccess.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports